import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(VCard,{staticClass:"pa-0 ma-0",attrs:{"flat":"","rounded":"0","width":"250"}},[_c(VCardText,[_c('table',[_c('tr',[_c('td',[_vm._v("velocity")]),_c('td',[_vm._v(_vm._s(_setup.orion.velocity))])]),_c('tr',[_c('td',[_vm._v("earth")]),_c('td',[_vm._v(_vm._s(_setup.orion.distance_earth))])]),_c('tr',[_c('td',[_vm._v("moon")]),_c('td',[_vm._v(_vm._s(_setup.orion.distance_moon))])])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }